var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobseekerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2209 18.3566L15.3037 13.2914C14.9511 12.928 14.5104 12.7825 14.3194 12.9683C14.1278 13.1527 13.6868 13.0076 13.3342 12.6442L13.2639 12.5715C15.4647 9.68531 15.2511 5.55297 12.6083 2.91778C9.72393 0.04173 5.04728 0.04173 2.16327 2.91778C-0.721091 5.79383 -0.721091 10.4563 2.16327 13.3324C4.85109 16.0128 9.09333 16.1923 11.9938 13.8773L12.0246 13.9094C12.3766 14.2728 12.5077 14.7168 12.3155 14.9016C12.1242 15.0864 12.2544 15.5307 12.6073 15.8935L17.5219 20.9607C17.8745 21.3231 18.4555 21.3339 18.8203 20.982L20.1996 19.6513C20.563 19.3003 20.5728 18.7213 20.2209 18.3566ZM10.9852 11.7139C9.00034 13.6934 5.77032 13.6934 3.78572 11.7146C1.80082 9.73537 1.80112 6.5143 3.78572 4.53548C5.77032 2.55631 9.00034 2.55661 10.9846 4.53579C12.9698 6.51466 12.9698 9.73507 10.9852 11.7139Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobseekerIcon);
export default __webpack_public_path__ + "static/media/jobseeker-icon.ad449ce073800bca0234d34a23403f06.svg";
export { ForwardRef as ReactComponent };